import React from 'react';
import { PACKAGES } from '../../config/packages';

export const Section = ({ title, subtitle, children, danger = false }) => (
  <div className={`admin-section ${danger ? 'danger' : ''}`}>
    {title && (
      <div className="admin-section-header">
        <h3 className="admin-section-title">{title}</h3>
        {subtitle && <p className="admin-section-subtitle">{subtitle}</p>}
      </div>
    )}
    <div className="admin-section-body">{children}</div>
  </div>
);

export const InfoRow = ({ label, value, mono = false }) => (
  <div className="admin-info-row">
    <span className="admin-info-label">{label}</span>
    <span className={`admin-info-value ${mono ? 'mono' : ''}`}>{value}</span>
  </div>
);

export const StatGrid = ({ items }) => (
  <div className="admin-stat-grid">
    {items.map((s) => (
      <div key={s.label} className="admin-stat">
        <span className="admin-stat-label">{s.label}</span>
        <span className="admin-stat-value">{s.value}</span>
      </div>
    ))}
  </div>
);

export const Select = ({ label, value, onChange, options }) => (
  <div className="input-wrapper">
    {label && <label className="input-label">{label}</label>}
    <select className="admin-select" value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </div>
);

export const PackageSelect = ({ value, onChange, label = 'Package' }) => (
  <Select label={label} value={value} onChange={onChange} options={PACKAGES} />
);

export const PositionSelect = ({ value, onChange }) => (
  <Select
    label="Position"
    value={value}
    onChange={onChange}
    options={[{ value: '0', label: 'Left' }, { value: '1', label: 'Right' }]}
  />
);

export const Loading = () => <div className="admin-loading">Loading...</div>;
